import { ShopTypes } from '~/lib/data-contract';
import { usePrice } from '~/services/shop/hooks';
import { useTranslations } from '~/services/umbraco/hooks';
import { useRawHtml } from '~/shared/components/RawHtml';
import { useCurrency } from '~/shared/hooks';
import { Text } from '../styled';

interface Package {
    pack: ShopTypes.ProductQueryPackaging;
}

export function Package({ pack }: Package) {
    const formatCurrency = useCurrency();
    const { translate } = useTranslations();

    const { data: prices, isLoading } = usePrice(pack.itemNumber ?? '', !!pack.itemNumber);

    const { salesUnitFormatted, salesUnitLookup, packingReturnPriceHandIn } = pack;
    const deliveryPrice = prices?.price?.price?.priceInclVat;
    const salesUnit = salesUnitFormatted || salesUnitLookup;
    const returnHandInPrice = packingReturnPriceHandIn?.priceInclVat;

    const packagingAndSurcharges = useRawHtml(
        translate('product.packagingAndSurchargesText')
            .replace(
                '[UNITS_PER_EMBALLAGE]',
                pack?.unitsPerEmballage ? String(pack?.unitsPerEmballage) : '',
            )
            .replace(
                '[PACKING_RETURN_PRICE_DELIVERY_PRICE_INCL_VAT]',
                isLoading ? '...' : formatCurrency(deliveryPrice || 0),
            )
            .replace('[PACKAGINGS_NAME]', pack?.name ? String(pack?.name) : '')
            .replace('[PACKAGINGS_NAME2]', pack?.name2 ? String(pack?.name2) : '')
            .replace(
                '[PACKING_RETURN_PRICE_HAND_IN_PRICE_INCL_VAT]',
                formatCurrency(returnHandInPrice || 0),
            )
            .replace('[SALES_UNIT_FORMATTED]', salesUnit || ''),
    );

    return <Text>{packagingAndSurcharges}</Text>;
}
